module.exports = __webpack_public_path__ + "static/media/calendario-2023-i.846ecc50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendario-2023-i.jpg
// module id = 832
// module chunks = 0